import AppIcon from "common/app-icon";
import * as React from "react";
import { styled } from "webapp/styled-components";
import { BasePicker } from "../base-picker/base-picker";

const Labels = styled.div`
    .title {
        ${p => p.theme.fontStyles.Body5};
    }
    .desc {
        ${p => p.theme.fontStyles.Caption7};
    }
`;

interface Props {
    readonly hasEvent: boolean;
    readonly isRequired: boolean;
    readonly isEnabled: boolean;
    readonly placeholder: string;

    readonly className?: string;
    readonly title?: string;
    readonly eventTitle?: string;
    readonly eventDesc?: string;

    readonly onClick?: () => void;
    readonly onClear?: () => void;
}

const EventPickerButton: React.FunctionComponent<Props> = p => {
    const {
        title,
        eventTitle,
        eventDesc,
        isRequired,
        hasEvent,
        isEnabled,
        placeholder,
        className,
        onClick,
        onClear,
    } = p;

    const onClearCallback = React.useCallback(
        (ev: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
            onClear?.();
            ev.preventDefault();
            ev.stopPropagation();
        },
        [onClear]
    );

    return (
        <BasePicker
            className={className}
            title={title}
            onClick={onClick}
            isEnabled={isEnabled}
            isRequired={isRequired}
            isPlaceholder={!hasEvent}
            leftItem={<AppIcon icon="01-21-calendar-add" size={20} />}
            rightItem={hasEvent ? "clear" : undefined}
            rightItemOnClick={hasEvent ? onClearCallback : undefined}>
            {hasEvent ? (
                <Labels>
                    <div className="title">{eventTitle}</div>
                    <div className="desc">{eventDesc}</div>
                </Labels>
            ) : (
                placeholder
            )}
        </BasePicker>
    );
};

export default EventPickerButton;
